/** Powered by @ttoss/config. https://ttoss.dev/docs/modules/packages/config/ */

// src/Provider.tsx
import * as React from "react";
import { Flex, InfiniteLinearProgress } from "@ttoss/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var NotificationsContext = React.createContext({
  isLoading: false,
  setLoading: () => {
    return void 0;
  },
  setNotifications: () => {
    return void 0;
  }
});
var NotificationsProvider = ({
  children,
  enableNotificationBox
}) => {
  const [isLoading, setLoading] = React.useState(false);
  const [notifications, setNotifications] = React.useState();
  return /* @__PURE__ */ jsxs(
    NotificationsContext.Provider,
    {
      value: {
        isLoading,
        setLoading,
        setNotifications,
        notifications,
        enableNotificationBox
      },
      children: [
        isLoading && /* @__PURE__ */ jsx(Flex, { sx: { position: "absolute", width: "100%", top: 0 }, children: /* @__PURE__ */ jsx(InfiniteLinearProgress, {}) }),
        children
      ]
    }
  );
};
var useNotifications = () => {
  const { isLoading, setLoading, notifications, setNotifications } = React.useContext(NotificationsContext);
  return {
    isLoading,
    setLoading,
    notifications,
    setNotifications
  };
};

// src/NotificationBox.tsx
import { Box } from "@ttoss/ui";
import { jsx as jsx2 } from "react/jsx-runtime";
var NotificationBox = () => {
  const { notifications } = useNotifications();
  if (!notifications) {
    return null;
  }
  return /* @__PURE__ */ jsx2(Box, { children: JSON.stringify(notifications, null, 2) });
};
export {
  NotificationBox,
  NotificationsProvider,
  useNotifications
};
